/* 9 Art Prints: collection soundtrack. Native HTML5 audio, no libraries.
   The audio element and its src are only created when the visitor presses "Listen while you browse". */
(function () {
  var root = document.querySelector('[data-cs]');
  if (!root) return;
  var audio = null;
  var toggleBtn = root.querySelector('[data-cs-toggle]');
  var muteBtn = root.querySelector('[data-cs-mute]');
  var range = root.querySelector('[data-cs-volume]');
  var startBtn = root.querySelector('[data-cs-start]');

  // Analytics: "soundtrack_play" when the music first sounds; then, with the seconds listened,
  // "soundtrack_stop" when the visitor closes the player or "soundtrack_leave" when they leave the page with
  // it still open (2026-10-12: split so the two can be told apart). Sent to Google Analytics through the gtag the
  // Google & YouTube app already loads; silently does nothing when that is absent (no consent, blocked).
  var played = false, listened = 0, since = 0;
  function tick() { if (since) { listened += (Date.now() - since) / 1000; since = 0; } }
  function track(name, extra) {
    try {
      if (typeof window.gtag !== 'function') return;
      var t = root.querySelector('.cs__t'), p = { soundtrack_title: t ? t.textContent : '', soundtrack_page: location.pathname }, k;
      for (k in extra) p[k] = extra[k];
      var ids = [].filter.call(window.dataLayer || [], function (a) { return a && a[0] === 'config' && /^G-/.test(a[1]); })
        .map(function (a) { return a[1]; });
      if (ids.length) p.send_to = ids;
      window.gtag('event', name, p);
    } catch (e) {}
  }
  function report(name) {
    tick();
    if (!played) return;
    var s = Math.round(listened);
    played = false; listened = 0;
    track(name, { listen_seconds: s, value: s });
  }

  function sync() {
    var playing = audio && !audio.paused;
    root.classList.toggle('is-playing', !!playing);
    toggleBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    var muted = audio && (audio.muted || audio.volume === 0);
    root.classList.toggle('is-muted', !!muted);
    muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
    muteBtn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
  }

  function start() {
    if (!audio) {
      audio = new Audio();
      audio.preload = 'none';
      audio.loop = true;
      audio.volume = parseFloat(range.value);
      ['play', 'pause', 'volumechange'].forEach(function (e) { audio.addEventListener(e, sync); });
      audio.addEventListener('playing', function () {
        if (!since) since = Date.now();
        if (!played) { played = true; track('soundtrack_play'); }
      });
      audio.addEventListener('pause', tick);
      audio.src = root.getAttribute('data-src');
    }
    root.classList.add('is-active');
    var p = audio.play();
    if (p && p.catch) p.catch(sync);
    toggleBtn.focus();
    sync();
  }

  function stop() {
    report('soundtrack_stop');
    if (audio) {
      audio.pause();
      audio.removeAttribute('src');
      audio.load();
      audio = null;
    }
    root.classList.remove('is-active', 'is-playing', 'is-muted');
    startBtn.focus();
  }

  startBtn.addEventListener('click', start);
  toggleBtn.addEventListener('click', function () {
    if (!audio) return start();
    if (audio.paused) audio.play(); else audio.pause();
  });
  muteBtn.addEventListener('click', function () {
    if (!audio) return;
    audio.muted = !audio.muted;
    if (!audio.muted && audio.volume === 0) { audio.volume = 0.5; range.value = 0.5; }
  });
  range.addEventListener('input', function () {
    if (!audio) return;
    audio.volume = parseFloat(range.value);
    audio.muted = audio.volume === 0;
  });
  root.querySelector('[data-cs-stop]').addEventListener('click', stop);
  // Leaving the page (including into the back/forward cache) always ends the music.
  window.addEventListener('pagehide', function () { if (audio) { audio.pause(); } report('soundtrack_leave'); root.classList.remove('is-playing'); });
})();
